import { IconLocation16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './GeoSwitcher.css';

interface IGeoSwitcherProps {
  title: string;
  onClick(): void;
}

export const GeoSwitcher: React.FC<IGeoSwitcherProps> = ({ title, onClick }) => {
  return (
    <div className={styles['wrapper']}>
      <button onClick={onClick} className={styles['button']}>
        <IconLocation16 color="icon-inverted-default" /> <span className={styles['text']}>{title}</span>
      </button>
    </div>
  );
};
